import { DataBean } from "../DataBean";


export class Secop extends DataBean {

    public async getSecopInfoByContractCode(idEmploye: number, contractCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getSecopInfoByContractCode_Number_String", [idEmploye, contractCode]);
    }

    public async getSecopContratosAvanzado(nitEntidad: string, proveedor: string, estado: string, ciudad: string, referencia: string, page: number, rows: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getSecopContratosAvanzado_String_String_String_String_String_Number_Number", [nitEntidad, proveedor, estado, ciudad, referencia, page, rows]);
    }

    public async getSecopProcessAdjudicated(idEmploye: number, idPortfolio: string, page: number, rows: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getSecopProcessAdjudicated_String_String_Number_Number", [idEmploye, idPortfolio, page, rows]);
    }

    public async getPortfolioByID(idPortfolio: string, page: number, rows: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getPortfolioByID_String_Number_Number", [idPortfolio, page, rows]);
    }

}